<template>
    <div>
        <RentableOutsideSwitzerlandFilter />
    </div>
</template>

<script>
import RentableOutsideSwitzerlandFilter from '~/components/vehicles/RentableOutsideSwitzerlandFilter';

export default {
    name: 'VehicleSearchBanner',
    components: { RentableOutsideSwitzerlandFilter },
};
</script>

<style lang="scss">
@import '@/sass/_variables.scss';

.vehicle-search-banner {
    margin: 0 auto;
    padding: 24px 20px 12px;

    &__content {
        position: relative;
        padding: 16px;
        display: flex;
        border: 2px solid $tertiary;
        border-radius: $default-border-radius;
        background: $white;
    }

    &__close {
        position: absolute;
        top: 8px;
        right: 16px;

        .svg-icon {
            width: 24px;
            height: 24px;
        }
    }

    &__title {
        font-weight: bold;
    }

    &__desktop-img {
        display: none;

        @include lg {
            display: block;
            margin-right: 40px;
        }
    }

    &__mobile-img {
        @include lg {
            display: none;
        }
    }

    &__description {
        display: flex;
        align-items: center;
        margin: 16px 0;

        span {
            margin-right: 16px;
            max-width: 350px;
        }

        @include lg {
            display: block;
            margin: 8px 0;
            max-width: unset;
        }
    }

    &__description,
    &__toggle {
        @include font-size(14px);
    }

    p {
        margin-bottom: 0;
    }

    &__toggle {
        display: flex;
        align-items: center;

        p {
            margin-right: 16px;
            font-weight: 600;
        }
    }

    @include lg {
        max-width: 850px;
    }
}
</style>
